import { CallCenterClientManagementTableColumns } from 'src/app/call-center-client-management/model/call-center-client-management-table-columns.model';
import { CallRecordTableColumns } from 'src/app/call-record-management/model/call-record-table-columns.model';
import { ReportDevicesChangedTableColumns, ReportDevicesTableColumns, ReportTableColumns } from 'src/app/periodic-review/models/report-table-columns.model';
import { AccountManagerTableColumns } from '../models/table-columns/account-manager-table-columns.model';
import { ActivityFileManagementTableColumns } from '../models/table-columns/activityFileManagement-table-columns.model';
import {
    AdminTableColumns,
    CompletedMeRequestOperationTableColumns,
    CompletedMeRequestTableColumns,
    DashboardTableColumns,
    InProgressTableColumns,
    SecurityCordinatorRequestTableColumns
} from '../models/table-columns/admin-table-columns.model';
import { EServiceHistoryFeildsTableColumns, EServiceTableColumns } from '../models/table-columns/e-service-table-columns.model';
import { EmployeeTableColumns, EmployeeTableclosedDateColumns } from '../models/table-columns/employee-table-columns.model';
import { RequesterTableColumns } from '../models/table-columns/requester-table-columns.model';
import { TableColumnItem } from '../models/table-columns/table-column-item.model';
import { TicketingTableColumns } from '../models/table-columns/ticketing-table-columns.model';

export class TablePropertiesConstants {
    public static REQUEST_NUMBER = 'requestNumber';
    public static SENDER = 'sender';
    public static CLIENT = 'client';
    public static SERVICE = 'service';
    public static DATE_TIME = 'dateAndTime';
    public static SLA = 'sla';
    public static ASSIGNEE = 'assignee';
    public static COMPLETED_BY_TO = 'completedByTo';
    public static STATUS = 'status';
    public static STATUSTXT = 'statusTxt';
    public static MESSAGE = 'message';
    public static BUTTON = 'button';
    public static CREATE_DATE = 'creationDate';
    public static CLOSED_DATE = 'closedDate';
    public static CLOSED_DATE_OPERATION = 'operationclosedDate';
    public static No = 'eServiceNumber';
    public static REQUESTER = 'requester';
    public static MAINTYPE = 'mainType';
    public static SUBTYPE = 'subType';
    public static PRIORITY = 'priority';
    public static USER = 'user';
    public static FILE = 'file';
    public static TYPE = 'type';
    public static REPORT_CODE = 'reportCode';
    public static ACTIONS = 'actions';
    public static REPORT_NAME = 'reportName';
    public static BUTTON_REPORT = 'buttonReport';
    public static AUDITOR = 'auditor';
    public static CLOSED_DATE_REPORT = 'closedDateReport';
    public static AUDIT_TYPE = 'auditType';
    public static SERIAL_NUMBER = 'serialNumber';
    public static DEVICE_NAME = 'deviceName';
    public static OWNER = 'owner';
    public static DEPARTMENT = 'department';
    public static REQUEST_DATE = 'requestDate';
    public static RETURNED_DATE = 'returnedDate';
    public static REPORT_REQUEST_DATE = 'reportRequestDate';
    public static FIELD_NAME = 'filedName';
    public static OLD_VALUE = 'oldValue';
    public static NEW_VALUE = 'newValue';
    public static SOURCE = 'source';
    public static USER_DEVICE_CHANGED = 'userDeviceChanged';
    public static DATE = 'date';
    public static Number = 'number';
    public static Employee = 'employee';
    public static phoneNumber = 'phoneNumber';
    public static CREATED_BY = 'createdBy';
    public static FEILD_TYPE = 'feildType';
    public static FEILD_ACTION = 'feildAction';

    public static TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.id}`
        },
        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.sender}`
        },
        {
            columnDef: this.CLIENT,
            header: this.CLIENT,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.client}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.date}`
        }
    ];
    public static TABLE_COLUMNS_WITH_CLOSED_DATE: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.id}`
        },
        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.sender}`
        },
        {
            columnDef: this.CLIENT,
            header: this.CLIENT,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.client}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.date}`
        },

        {
            columnDef: this.CLOSED_DATE,
            header: this.CLOSED_DATE,
            cell: (element: EmployeeTableclosedDateColumns) => `${element.closedDate}`
        }
    ];
    public static TABLE_COLUMNS_WITH_SLA: TableColumnItem[] = [
        ...TablePropertiesConstants.TABLE_COLUMNS,
        {
            columnDef: this.SLA,
            header: this.SLA,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.date}`
        }
    ];

    public static TABLE_COLUMNS_WITH_ASSIGNEE: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.id}`
        },
        {
            columnDef: this.ASSIGNEE,
            header: this.ASSIGNEE,
            cell: (element: InProgressTableColumns) => `${element.assignee}`
        },
        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.sender}`
        },
        {
            columnDef: this.CLIENT,
            header: this.CLIENT,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.client}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.date}`
        }
    ];
    public static TABLE_COLUMNS_WITH_ASSIGNEE_COMPLETED_BY_TO: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.id}`
        },
        {
            columnDef: this.COMPLETED_BY_TO,
            header: this.COMPLETED_BY_TO,
            cell: (element: InProgressTableColumns) => `${element.assignee}`
        },
        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.sender}`
        },
        {
            columnDef: this.CLIENT,
            header: this.CLIENT,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.client}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.date}`
        }
    ];
    public static TABLE_COLUMNS_WITH_ASSIGNEE_CLOSED_DATE: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.id}`
        },
        {
            columnDef: this.ASSIGNEE,
            header: this.ASSIGNEE,
            cell: (element: InProgressTableColumns) => `${element.assignee}`
        },
        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.sender}`
        },
        {
            columnDef: this.CLIENT,
            header: this.CLIENT,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.client}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.date}`
        },

        {
            columnDef: this.CLOSED_DATE,
            header: this.CLOSED_DATE,
            cell: (element: CompletedMeRequestTableColumns) => `${element.closedDate}`
        }
    ];
    public static TABLE_COLUMNS_WITH_ASSIGNEE_CLOSED_DATE_COMPLETED_BY_TO: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.id}`
        },
        {
            columnDef: this.COMPLETED_BY_TO,
            header: this.COMPLETED_BY_TO,
            cell: (element: InProgressTableColumns) => `${element.assignee}`
        },
        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.sender}`
        },
        {
            columnDef: this.CLIENT,
            header: this.CLIENT,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.client}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.date}`
        },

        {
            columnDef: this.CLOSED_DATE,
            header: this.CLOSED_DATE,
            cell: (element: CompletedMeRequestTableColumns) => `${element.closedDate}`
        }
    ];
    public static DASHBOARD_COLUMNS_WITH_ASSIGNEE: TableColumnItem[] = [
        ...TablePropertiesConstants.TABLE_COLUMNS_WITH_ASSIGNEE,
        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: DashboardTableColumns) => `${element.status}`
        }
    ];
    public static TABLE_COLUMNS_WITH_REQUSTER: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.id}`
        },
        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.sender}`
        },

        {
            columnDef: this.REQUESTER,
            header: this.CREATED_BY,
            cell: (element: SecurityCordinatorRequestTableColumns) => `${element.requester}`
        },
        {
            columnDef: this.CLIENT,
            header: this.CLIENT,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.client}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.date}`
        }
    ];
    public static SECURITY_COORDINATOR_REQUESTS_COLUMNS: TableColumnItem[] = [
        ...TablePropertiesConstants.TABLE_COLUMNS_WITH_REQUSTER,
        {
            columnDef: this.STATUSTXT,
            header: this.STATUSTXT,
            cell: (element: DashboardTableColumns) => `${element.statustxt}`
        }
    ];

    public static COMPLETED_HISTORY_REQUESTS_COLUMNS: TableColumnItem[] = [
        ...TablePropertiesConstants.TABLE_COLUMNS_WITH_ASSIGNEE_COMPLETED_BY_TO,
        {
            columnDef: this.SLA,
            header: this.SLA,
            cell: (element: AdminTableColumns | EmployeeTableColumns) => `${element.date}`
        },
        {
            columnDef: this.CLOSED_DATE_OPERATION,
            header: this.CLOSED_DATE_OPERATION,
            cell: (element: CompletedMeRequestOperationTableColumns) => `${element.operationclosedDate}`
        }
    ];

    public static REQUESTER_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: RequesterTableColumns) => `${element.id}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: RequesterTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: RequesterTableColumns) => `${element.date}`
        },
        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: RequesterTableColumns) => `${element.date}`
        },
        {
            columnDef: this.CLOSED_DATE,
            header: this.CLOSED_DATE,
            cell: (element: CompletedMeRequestTableColumns) => `${element.closedDate}`
        }
    ];
    public static REQUESTER_TABLE_COLUMNS_INPROGRESS: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: RequesterTableColumns) => `${element.id}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: RequesterTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: RequesterTableColumns) => `${element.date}`
        },
        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: RequesterTableColumns) => `${element.date}`
        }
    ];
    public static ACCOUNTMANAGER_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: AccountManagerTableColumns) => `${element.id}`
        },
        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: AccountManagerTableColumns) => `${element.sender}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: AccountManagerTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: AccountManagerTableColumns) => `${element.date}`
        },
        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: AccountManagerTableColumns) => `${element.date}`
        }
    ];

    public static ACCOUNTMANAGER_TABLE_COLUMNS_WOTH_CLOSED_DATE: TableColumnItem[] = [
        ...TablePropertiesConstants.ACCOUNTMANAGER_TABLE_COLUMNS,
        {
            columnDef: this.CLOSED_DATE,
            header: this.CLOSED_DATE,
            cell: (element: CompletedMeRequestTableColumns) => `${element.closedDate}`
        }
    ];
    public static TICKETING_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: TicketingTableColumns) => `${element.id}`
        },
        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: TicketingTableColumns) => `${element.sender}`
        },

        {
            columnDef: this.DATE_TIME,
            header: this.CREATE_DATE,
            cell: (element: TicketingTableColumns) => `${element.date}`
        },
        {
            columnDef: this.MESSAGE,
            header: this.MESSAGE,
            cell: (element: TicketingTableColumns) => `${element.message}`
        },
        {
            columnDef: this.BUTTON,
            header: this.BUTTON,
            cell: (element: TicketingTableColumns) => `${''}`
        }
    ];
    public static ACCOUNTMANAGEREMPLOYEEMANAGEMANT_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: AccountManagerTableColumns) => `${element.id}`
        },

        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: AccountManagerTableColumns) => `${element.service}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: AccountManagerTableColumns) => `${element.date}`
        },
        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: AccountManagerTableColumns) => `${element.date}`
        }
    ];

    public static TECHNICAL_OPERATIONS_REQUESTS_COLUMNS: TableColumnItem[] = [
        ...TablePropertiesConstants.TABLE_COLUMNS_WITH_SLA,
        {
            columnDef: this.STATUSTXT,
            header: this.STATUSTXT,
            cell: (element: DashboardTableColumns) => `${element.statustxt}`
        },
        {
            columnDef: this.CLOSED_DATE_OPERATION,
            header: this.CLOSED_DATE_OPERATION,
            cell: (element: CompletedMeRequestOperationTableColumns) => `${element.operationclosedDate}`
        }
    ];

    public static TICKETING_ESERVICES_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.No,
            header: this.No,
            cell: (element: EServiceTableColumns) => `${element.number}`
        },
        {
            columnDef: this.REQUESTER,
            header: this.REQUESTER,
            cell: (element: EServiceTableColumns) => `${element.requester}`
        },
        {
            columnDef: this.MAINTYPE,
            header: this.MAINTYPE,
            cell: (element: EServiceTableColumns) => `${element.mainType}`
        },
        {
            columnDef: this.SUBTYPE,
            header: this.SUBTYPE,
            cell: (element: EServiceTableColumns) => `${element.subType}`
        },

        {
            columnDef: this.DATE_TIME,
            header: this.CREATE_DATE,
            cell: (element: EServiceTableColumns) => `${element.date}`
        },

        // {
        //     columnDef: this.PRIORITY,
        //     header: this.PRIORITY,
        //     cell: (element: EServiceTableColumns) => `${element.priority}`
        // },
        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: EServiceTableColumns) => `${element.status}`
        },
        {
            columnDef: this.BUTTON,
            header: this.BUTTON,
            cell: (element: EServiceTableColumns) => `${''}`
        }
    ];
    public static ESERVICES_HISTORY_FILEDS_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.FIELD_NAME,
            header: this.FIELD_NAME,
            cell: (element: EServiceHistoryFeildsTableColumns) => `${element.fieldName}`
        },
        {
            columnDef: this.OLD_VALUE,
            header: this.OLD_VALUE,
            cell: (element: EServiceHistoryFeildsTableColumns) => `${element.oldFeild}`
        },
        {
            columnDef: this.NEW_VALUE,
            header: this.NEW_VALUE,
            cell: (element: EServiceHistoryFeildsTableColumns) => `${element.newFeild}`
        },
        {
            columnDef: this.USER,
            header: this.USER,
            cell: (element: EServiceHistoryFeildsTableColumns) => `${element.userName}`
        },

        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: EServiceHistoryFeildsTableColumns) => `${element.date}`
        },

        {
            columnDef: this.FEILD_TYPE,
            header: this.FEILD_TYPE,
            cell: (element: EServiceHistoryFeildsTableColumns) => `${element.fieldType}`
        },
        {
            columnDef: this.FEILD_ACTION,
            header: this.FEILD_ACTION,
            cell: (element: EServiceHistoryFeildsTableColumns) => `${element.fieldAction}`
        }
    ];
    public static ACTIVITY_FILE_MANAGEMENT_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.USER,
            header: this.USER,
            cell: (element: ActivityFileManagementTableColumns) => `${element.user}`
        },
        {
            columnDef: this.FILE,
            header: this.FILE,
            cell: (element: ActivityFileManagementTableColumns) => `${element.file}`
        },
        {
            columnDef: this.TYPE,
            header: this.TYPE,
            cell: (element: ActivityFileManagementTableColumns) => `${element.type}`
        },

        {
            columnDef: this.DATE_TIME,
            header: this.CREATE_DATE,
            cell: (element: ActivityFileManagementTableColumns) => `${element.date}`
        }
    ];
    public static REPORT_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.REPORT_CODE,
            header: this.REPORT_CODE,
            cell: (element: ReportTableColumns) => `${element.code}`
        },
        // {
        //     columnDef: this.REPORT_NAME,
        //     header: this.REPORT_NAME,
        //     cell: (element: ReportTableColumns) => `${element.reportTypeName}`
        // },
        {
            columnDef: this.AUDITOR,
            header: this.AUDITOR,
            cell: (element: ReportTableColumns) => `${element.creator}`
        },
        {
            columnDef: this.AUDIT_TYPE,
            header: this.AUDIT_TYPE,
            cell: (element: ReportTableColumns) => `${element.auditType}`
        },

        {
            columnDef: this.DATE_TIME,
            header: this.CREATE_DATE,
            cell: (element: ReportTableColumns) => `${element.createdAt}`
        },
        {
            columnDef: this.CLOSED_DATE,
            header: this.CLOSED_DATE_REPORT,
            cell: (element: ReportTableColumns) => `${element.closedAt! || null}`
        },

        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: ReportTableColumns) => `${element.reportStatus}`
        },
        {
            columnDef: this.BUTTON_REPORT,
            header: this.BUTTON_REPORT,
            cell: (element: ReportTableColumns) => `${''}`
        }
    ];
    public static REPORT_TABLE_LOGISTIC_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.REPORT_CODE,
            header: this.REPORT_CODE,
            cell: (element: ReportTableColumns) => `${element.code}`
        },

        {
            columnDef: this.AUDITOR,
            header: this.AUDITOR,
            cell: (element: ReportTableColumns) => `${element.creator}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.CREATE_DATE,
            cell: (element: ReportTableColumns) => `${element.createdAt}`
        },

        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: ReportTableColumns) => `${element.reportStatus}`
        },
        {
            columnDef: this.BUTTON_REPORT,
            header: this.BUTTON_REPORT,
            cell: (element: ReportTableColumns) => `${''}`
        }
    ];
    public static REPORT_TABLE_LOGISTIC_DEVICE_ALL_ITEMS_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.SERIAL_NUMBER,
            header: this.SERIAL_NUMBER,
            cell: (element: ReportDevicesTableColumns) => `${element.serialNumber}`
        },

        {
            columnDef: this.DEVICE_NAME,
            header: this.DEVICE_NAME,
            cell: (element: ReportDevicesTableColumns) => `${element.deviceName}`
        },
        {
            columnDef: this.OWNER,
            header: this.OWNER,
            cell: (element: ReportDevicesTableColumns) => `${element.ownerName + 'img' + element.ownerImage}`
        },

        {
            columnDef: this.DEPARTMENT,
            header: this.DEPARTMENT,
            cell: (element: ReportDevicesTableColumns) => `${element.departmentName}`
        },
        {
            columnDef: this.REPORT_REQUEST_DATE,
            header: this.REPORT_REQUEST_DATE,
            cell: (element: ReportDevicesTableColumns) => `${element.requestDate}`
        },
        {
            columnDef: this.RETURNED_DATE,
            header: this.RETURNED_DATE,
            cell: (element: ReportDevicesTableColumns) => `${element.returnedDate}`
        },
        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: ReportDevicesTableColumns) => `${element.reportStatusName}`
        },

        {
            columnDef: this.BUTTON_REPORT,
            header: this.BUTTON_REPORT,
            cell: (element: ReportDevicesTableColumns) => `${''}`
        }
    ];
    public static REPORT_TABLE_LOGISTIC_DEVICE_ALL_ITEMS_COLUMNS_SHARED: TableColumnItem[] = [
        {
            columnDef: this.SERIAL_NUMBER,
            header: this.SERIAL_NUMBER,
            cell: (element: ReportDevicesTableColumns) => `${element.serialNumber}`
        },

        {
            columnDef: this.DEVICE_NAME,
            header: this.DEVICE_NAME,
            cell: (element: ReportDevicesTableColumns) => `${element.deviceName}`
        },

        {
            columnDef: this.REPORT_REQUEST_DATE,
            header: this.REPORT_REQUEST_DATE,
            cell: (element: ReportDevicesTableColumns) => `${element.requestDate}`
        },
        {
            columnDef: this.RETURNED_DATE,
            header: this.RETURNED_DATE,
            cell: (element: ReportDevicesTableColumns) => `${element.returnedDate}`
        },
        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: ReportDevicesTableColumns) => `${element.reportStatusName}`
        },

        {
            columnDef: this.BUTTON_REPORT,
            header: this.BUTTON_REPORT,
            cell: (element: ReportDevicesTableColumns) => `${''}`
        }
    ];
    public static DEVICE_CHANGED_TABLE: TableColumnItem[] = [
        {
            columnDef: this.FIELD_NAME,
            header: this.FIELD_NAME,
            cell: (element: ReportDevicesChangedTableColumns) => `${element.field}`
        },

        {
            columnDef: this.OLD_VALUE,
            header: this.OLD_VALUE,
            cell: (element: ReportDevicesChangedTableColumns) => `${element.oldValue}`
        },
        {
            columnDef: this.NEW_VALUE,
            header: this.NEW_VALUE,
            cell: (element: ReportDevicesChangedTableColumns) => `${element.newValue}`
        },
        {
            columnDef: this.USER_DEVICE_CHANGED,
            header: this.USER_DEVICE_CHANGED,
            cell: (element: ReportDevicesChangedTableColumns) => `${element.userName + 'email' + element.userEmail + 'img' + element.userImage}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE,
            cell: (element: ReportDevicesChangedTableColumns) => `${element.createdAt}`
        },

        {
            columnDef: this.SOURCE,
            header: this.SOURCE,
            cell: (element: ReportDevicesChangedTableColumns) => `${element.changeSource}`
        }
    ];

    public static CALL_RECORD_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.Number,
            header: this.Number,
            cell: (element: CallRecordTableColumns) => `${element.code}`
        },
        {
            columnDef: this.Employee,
            header: this.Employee,
            cell: (element: CallRecordTableColumns) => `${element.employeeName}`
        },
        {
            columnDef: this.phoneNumber,
            header: this.phoneNumber,
            cell: (element: CallRecordTableColumns) => `${element.mobilePhoneNumber}`
        },

        {
            columnDef: this.CLIENT,
            header: this.CLIENT,
            cell: (element: CallRecordTableColumns) => `${element.clientName}`
        },
        {
            columnDef: this.REQUESTER,
            header: this.REQUESTER,
            cell: (element: CallRecordTableColumns) => `${element.requesterDataName}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: CallRecordTableColumns) => `${element.serviceName}`
        },

        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: CallRecordTableColumns) => `${element.createdAt}`
        },

        {
            columnDef: this.STATUS,
            header: this.STATUS,
            cell: (element: CallRecordTableColumns) => `${element.status}`
        },
        {
            columnDef: this.BUTTON,
            header: this.BUTTON,
            cell: (element: TicketingTableColumns) => `${''}`
        }
    ];
    public static CALL_CENTER_CLIENT_MANAGEMRNT_REQUEST_TABLE_COLUMNS: TableColumnItem[] = [
        {
            columnDef: this.REQUEST_NUMBER,
            header: this.REQUEST_NUMBER,
            cell: (element: CallCenterClientManagementTableColumns) => `${element.id}`
        },

        {
            columnDef: this.SENDER,
            header: this.SENDER,
            cell: (element: CallCenterClientManagementTableColumns) => `${element.creatorName}`
        },
        {
            columnDef: this.REQUESTER,
            header: this.CREATED_BY,
            cell: (element: CallCenterClientManagementTableColumns) => `${element.requesterName}`
        },
        {
            columnDef: this.CLIENT,
            header: this.CLIENT,
            cell: (element: CallCenterClientManagementTableColumns) => `${element.requesterClientName}`
        },
        {
            columnDef: this.SERVICE,
            header: this.SERVICE,
            cell: (element: CallCenterClientManagementTableColumns) => `${element.requestType}`
        },
        {
            columnDef: this.DATE_TIME,
            header: this.DATE_TIME,
            cell: (element: CallCenterClientManagementTableColumns) => `${element.createdAt}`
        },
        {
            columnDef: this.STATUSTXT,
            header: this.STATUSTXT,
            cell: (element: CallCenterClientManagementTableColumns) => `${element.requestStatus}`
        }

        // ,{
        //     columnDef: this.SLA,
        //     header: this.SLA,
        //     cell: (element: CallCenterClientManagementTableColumns) => `${element.createdAt}`
        // }
    ];
}
